import { render } from "./SaveExpenseType.vue?vue&type=template&id=211ffd92&scoped=true"
import script from "./SaveExpenseType.vue?vue&type=script&lang=js"
export * from "./SaveExpenseType.vue?vue&type=script&lang=js"

import "../save-expensetype-event.scss?vue&type=style&index=0&id=211ffd92&lang=scss&scoped=true"

import exportComponent from "/srv/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-211ffd92"]])

export default __exports__